module.exports = __webpack_public_path__ + "static/media/address.6f166693.png";